export default "__VITE_ASSET__IHu6Rkbx__"